import { CCol, CContainer, CRow } from "@coreui/react";
import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationArrow,
  faLockOpen,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  // faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

export default function Footer() {
  return (
    <>
      <section className="footer-section-wrapper">
        <CContainer>
          <CRow className="gx-lg-5">
            <CCol lg={4} className="mb-4 mb-lg-0">
              <div className="footer-widget-wrapper">
                <h4>about us</h4>
                <div className="footer-widget-about">
                  <p className="mb-0 pe-5">
                    The Wattlecare provides support to eligible people with
                    intellectual, physical, sensory, cognitive, and psychosocial
                    disability.”
                  </p>
                  <div className="footer-24hours-wrapper mt-3">
                    <div className="footer-24hours-icon">
                      <span>
                        <FontAwesomeIcon icon={faLockOpen} />
                      </span>
                    </div>
                    <div className="footer-24hours-desc ps-3">
                      <label>open</label>
                      <h5>24x7</h5>
                    </div>
                  </div>
                </div>
              </div>
            </CCol>
            <CCol lg={2} className="mb-4 mb-lg-0">
              <div className="footer-widget-wrapper">
                <h4>main pages</h4>
                <div className="footer-widget-list">
                  <ul>
                    <li>
                      <Link to={"/"}>Home</Link>
                    </li>
                    <li>
                      <Link to={"/about"}>About</Link>
                    </li>
                    <li>
                      <Link to={"/services"}>Services</Link>
                    </li>
                    <li>
                      <Link to={"/contact"}>Contact</Link>
                    </li>
                    <li>
                      <Link to={"/feedback"}>Feedback</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </CCol>
            <CCol lg={3} className="mb-4 mb-lg-0">
              <div className="footer-widget-wrapper">
                <h4>get in touch</h4>
                <div className="footer-widget-info">
                  <div className="single-info-box mb-3">
                    <div className="single-info-icon">
                      <span>
                        <FontAwesomeIcon icon={faPhone} />
                      </span>
                    </div>
                    <div className="single-info-desc">
                      <Link to={"tel:1800204050"} style={{ fontFamily: "Poppins, sans-serif" }} className="d-block mb-2">
                        1800204050
                      </Link>
                    </div>
                  </div>
                  <div className="single-info-box mb-3">
                    <div className="single-info-icon">
                      <span>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </span>
                    </div>
                    <div className="single-info-desc">
                      <Link
                        to={"mailto:info@wattlecare.au"}
                        className="d-block"
                      >
                        info@wattlecare.au
                      </Link>
                    </div>
                  </div>
                  <div className="single-info-box">
                    <div className="single-info-icon">
                      <span>
                        <FontAwesomeIcon icon={faLocationArrow} />
                      </span>
                    </div>
                    <div className="single-info-desc">
                      <Link to={"#"} className="d-block">
                      Level 2, Suite 3, 91 George Street, Parramatta 2150 NSW
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="share-link-list">
                  <ul className="mb-0">
                    <li>
                      <label>Connect :</label>
                    </li>
                    <li>
                      <Link to="https://www.facebook.com/wattlecare" target="_blank">
                        <FontAwesomeIcon icon={faFacebook} />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.instagram.com/wattlecarendis25/" target="_blank">
                        <FontAwesomeIcon icon={faInstagram} />
                      </Link>
                    </li>
                    {/* <li>
                      <Link to={"#"}>
                        <FontAwesomeIcon icon={faLinkedin} />
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </CCol>
            <CCol lg={3} className="mb-4 mb-lg-0">
              <div className="footer-widget-wrapper">
                <h4>Contact Hours</h4>
                <div className="footer-widget-hours">
                  <ul>
                    <li>
                      <label>Mon - Fri  : 09.00 - 17.00</label>
                    </li>
                    <li>
                      <label>Sat - Sun  : 10.00 - 17.00</label>
                    </li>
                  </ul>
                </div>
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
